import { render, staticRenderFns } from "./ManageSearchStatus.vue?vue&type=template&id=23dd3c32&scoped=true"
import script from "./ManageSearchStatus.vue?vue&type=script&lang=js"
export * from "./ManageSearchStatus.vue?vue&type=script&lang=js"
import style0 from "./ManageSearchStatus.vue?vue&type=style&index=0&id=23dd3c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd3c32",
  null
  
)

export default component.exports